export const FORM_TEMPLATES_REQUEST = "FORM_TEMPLATES_REQUEST";
